export enum EnUserRole {
  customer = 'customer',
  administrator = 'administrator',
  educator = 'educator',
  professional = 'professional',
  responsible = 'responsible'
}
